import { render, staticRenderFns } from "./BlackGoldMobileNav.vue?vue&type=template&id=9da84f88"
import script from "./BlackGoldMobileNav.vue?vue&type=script&lang=js"
export * from "./BlackGoldMobileNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports